module.exports = __webpack_public_path__ + "img/SEJ enventos_registro.15389c46.svg";